import PropTypes from 'prop-types';
import TaskNumber from 'contents/ProtocolEditor/Components/TaskNumber';
import TaskTitle from 'contents/ProtocolEditor/TaskList/Task/Components/TaskTitle';
import TaskWrapper from 'contents/ProtocolEditor/TaskList/Task/Components/TaskWrapper';
import TaskAction from 'contents/ProtocolEditor/TaskList/Task/Components/TaskAction';
import {ExecutionStatus} from 'constants/dataEnum';
import Spinner from 'components/Spinner/Spinner';
import TaskExecutedTick from 'components/TaskExecutedTick';
import PipettingProfileItems from 'contents/ProtocolEditor/TaskList/PipettingProfile/PipettingProfileItem/PipettingProfileItems';
import TaskPipettingProfileWrapper from 'contents/ProtocolEditor/TaskList/Task/Components/TaskPipettingProfileWrapper';
import withIntl from '../../../../../../lib/withIntl';
import BroadcastTaskDescription from './TaskDescription/BroadcastTaskDescription';

function BroadcastDestinationVolume({
  disableDrag,
  disallowEdit,
  executionStatus,
  number,
  tasks,
  labware,
  labwareState,
  isHighlighted,
  intl,
  onEdit,
  onShowMenuContext,
  runtimeMode,
  reuseTips,
  readOnly,
  onReuseTipsChange,
  showEditButton,
}) {
  return (
    <TaskWrapper disableDrag={disableDrag} isSelected={isHighlighted} onContextMenu={onShowMenuContext}>
      <TaskNumber number={number} isHighlighted={isHighlighted} />
      <TaskTitle
        title="Broadcast: Destination volume"
        description={
          <BroadcastTaskDescription number={number} labware={labware} tasks={tasks} labwareState={labwareState} />
        }
      />
      {!runtimeMode && !readOnly && showEditButton && <TaskAction onEdit={onEdit} />}
      {!runtimeMode && disallowEdit && showEditButton && (
        <TaskPipettingProfileWrapper>
          <PipettingProfileItems.ReuseTips
            reuseTips={reuseTips}
            onReuseTipsChange={onReuseTipsChange}
            toolTipTitle={intl.formatMessage({id: 'protocolEditor.broadcast.reuseTip.info'})}
          />
        </TaskPipettingProfileWrapper>
      )}
      {runtimeMode && executionStatus === ExecutionStatus.EXECUTING && <Spinner />}
      {runtimeMode && executionStatus === ExecutionStatus.EXECUTED && <TaskExecutedTick />}
    </TaskWrapper>
  );
}

BroadcastDestinationVolume.propTypes = {
  disableDrag: PropTypes.bool,
  disallowEdit: PropTypes.bool,
  executionStatus: PropTypes.string.isRequired,
  number: PropTypes.number.isRequired,
  labware: PropTypes.object.isRequired,
  labwareState: PropTypes.object,
  isHighlighted: PropTypes.bool,
  intl: PropTypes.any.isRequired,
  tasks: PropTypes.object.isRequired,
  onEdit: PropTypes.func,
  onShowMenuContext: PropTypes.func.isRequired,
  runtimeMode: PropTypes.bool,
  reuseTips: PropTypes.bool,
  onReuseTipsChange: PropTypes.func,
  showEditButton: PropTypes.bool,
  readOnly: PropTypes.bool,
};

BroadcastDestinationVolume.defaultProps = {
  disableDrag: false,
  disallowEdit: false,
  labwareState: {},
  isHighlighted: false,
  onEdit: () => {},
  runtimeMode: false,
  reuseTips: true,
  onReuseTipsChange: () => {},
  showEditButton: false,
  readOnly: false,
};

export default withIntl(BroadcastDestinationVolume);
